exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-330b43f5]{position:fixed;inset:0;background:rgba(0,0,0,.4)}.modal[data-v-330b43f5]{--tw-bg-opacity:1;background-color:rgb(19 19 19/var(--tw-bg-opacity));border-width:2px;--tw-border-opacity:1;border-color:rgb(247 183 51/var(--tw-border-opacity));padding:1.25rem;text-align:left;position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);min-height:300px;min-width:calc(100% - 20px)}@media (min-width:768px){.modal[data-v-330b43f5]{min-width:500px}}", ""]);

// exports
